export default function Display() {
  return <div id="display"></div>;
}
